export default __webpack_public_path__ + "static/Service Advantage – Vertical 400x400-53aa54ff1e7b440d90b0c6c2707858a9.svg";